import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './MissingImage.module.css';

//#region [Props]
type MissingImageProps = {
  missingText?: string;
  aspect: string;
  className?: string;
};
//#endregion

//#region [Component]
export default function MissingImage(t0) {
  const $ = _c(10);
  const {
    missingText: t1,
    aspect,
    className
  } = t0;
  const missingText = t1 === undefined ? "Bilde mangler" : t1;
  let t2;
  if ($[0] !== aspect) {
    t2 = {
      aspectRatio: aspect
    };
    $[0] = aspect;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = classNames(styles.SMissingImage, className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== missingText) {
    t4 = <svg className={styles.SMissingSvg} viewBox="0 0 200 20"><text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle">{missingText}</text></svg>;
    $[4] = missingText;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div style={t2} className={t3}>{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
//#endregion